import { Component } from 'react'
import PropTypes from 'prop-types'

import { withAuthContext } from 'context/with-auth-context'
import { agent, bootstrapAgent } from 'agent'
import SupportAPI from 'SupportAPI'
import supportAgent from 'support/API'
import { sanitize, messageFromResponseError } from 'utils/strings'

class AgentContainer extends Component {
  static propTypes = {
    authState: PropTypes.object
  }

  renewalPromise = null

  componentDidMount() {
    bootstrapAgent()

    // Set up interceptors for agent
    const authInterceptor = config => {
      if (config.headers.Authorization) return config

      if (this.props.authState.authHeader)
        config.headers.Authorization = this.props.authState.authHeader

      return config
    }

    agent.interceptors.request.use(authInterceptor)

    agent.interceptors.response.use(
      undefined,
      this.handleUnauthorizedResponse(agent)
    )

    // LEGACY SUPPORT API
    supportAgent.interceptors.request.use(authInterceptor)

    supportAgent.interceptors.response.use(
      undefined,
      this.handleUnauthorizedResponse(supportAgent)
    )

    // NEW SUPPORT API
    SupportAPI.interceptors.request.use(authInterceptor)

    SupportAPI.interceptors.response.use(
      undefined,
      this.handleUnauthorizedResponse(supportAgent)
    )
  }

  handleUnauthorizedResponse = axiosInstance => err => {
    const { authState } = this.props

    const message = messageFromResponseError(err)
    if (message) {
      err.response.data = sanitize(message)
    }

    if (
      err.response &&
      err.response.status !== 401 &&
      err.response.status !== 403
    ) {
      throw err
    }

    if (message === 'Authentication token is expired') {
      // This header is bad, get rid of it
      delete err.config.headers.Authorization
      // If there is no pending renewal promise, start it. This avoids
      // sending duplicate renewal requests if multiple requests fail within
      // a short timeframe.
      if (!this.renewalPromise) this.renewalPromise = authState.renewSession()

      // After the renewal is done, retry the pending request
      return this.renewalPromise.then(() => {
        this.renewalPromise = null
        return axiosInstance(err.config)
      })
    } else if (
      message === 'Authentication token is invalid' ||
      message === 'Session not found' ||
      message === 'Identity not found' ||
      message === 'Session has been revoked' ||
      message === 'The trial for your company has expired' ||
      message === 'Identity has been deactivated'
    ) {
      authState.endSession()
    }

    throw err
  }

  render() {
    return null
  }
}

export default withAuthContext(AgentContainer)
